export const CONFIG_LOCALE = [
    { key: 'es', value: 'Spanish' },
    { key: 'en', value: 'english' },
    { key: 'ar', value: 'Arabic' },
    { key: 'at', value: 'Austria' },
    { key: 'ez', value: 'Azerbaijan' },
    { key: 'be', value: 'Belarusian' },
    { key: 'bg', value: 'Bulgarian' },
    { key: 'bn', value: 'Bangla' },
    { key: 'bs', value: 'Bosnian' },
    { key: 'cat', value: 'Catalan' },
    { key: 'cs', value: 'Czech' },
    { key: 'cy', value: 'Welsh' },
    { key: 'da', value: 'Danish' },
    { key: 'de', value: 'German' },
    { key: 'eo', value: 'Esperanto' },
    { key: 'es', value: 'Spanish' },
    { key: 'et', value: 'Estonian' },
    { key: 'fa', value: 'Persian' },
    { key: 'fi', value: 'Finnish' },
    { key: 'fo', value: 'Faroese' },
    { key: 'fr', value: 'French' },
    { key: 'ga', value: 'Irish' },
    { key: 'gr', value: 'Greek' },
    { key: 'he', value: 'Hebrew' },
    { key: 'hi', value: 'Hindi' },
    { key: 'hr', value: 'Croatian' },
    { key: 'hu', value: 'Hungarian' },
    { key: 'id', value: 'Indonesian' },
    { key: 'is', value: 'Icelandic' },
    { key: 'it', value: 'Italian' },
    { key: 'ja', value: 'Japanese' },
    { key: 'ge', value: 'Georgian' },
    { key: 'km', value: 'Khmer' },
    { key: 'ko', value: 'Korean' },
    { key: 'kz', value: 'Kazakh' },
    { key: 'lt', value: 'Lithuanian' },
    { key: 'lv', value: 'Latvian' },
    { key: 'mk', value: 'Macedonian' },
    { key: 'mn', value: 'Mongolian' },
    { key: 'ms', value: 'Malaysian' },
    { key: 'my', value: 'Burmese' },
    { key: 'nl', value: 'Dutch' },
    { key: 'no', value: 'Norwegian' },
    { key: 'pa', value: 'Punjabi' },
    { key: 'pl', value: 'Polish' },
    { key: 'pt', value: 'Portuguese' },
    { key: 'ro', value: 'Romanian' },
    { key: 'ru', value: 'Russian' },
    { key: 'si', value: 'Sinhala' },
    { key: 'sk', value: 'Slovak' },
    { key: 'sl', value: 'Slovenian' },
    { key: 'sq', value: 'Albanian' },
    { key: 'sr-cyr', value: 'SerbianCyrillic' },
    { key: 'sr', value: 'Serbian' },
    { key: 'sv', value: 'Swedish' },
    { key: 'th', value: 'Thai' },
    { key: 'tr', value: 'Turkish' },
    { key: 'uk', value: 'Ukrainian' },
    { key: 'uz-latn', value: 'UzbekLatin' },
    { key: 'uz', value: 'Uzbek' },
    { key: 'vn', value: 'Vietnamese' },
    { key: 'zh-tw', value: 'MandarinTraditional' },
    { key: 'zh', value: 'Mandarin' },
  ];
  